import type { ReactNode } from "react";
import Button from "@mui/material/Button";
import { TourCardHeadless, TourOverlayHeadless } from "@tour-kit/react/headless";

const DefinityTourShell = () => (
  <>
    <TourOverlayHeadless
      render={({ overlayStyle, cutoutStyle, targetRect }) => (
        <div style={overlayStyle} className="z-modal">
          {targetRect && <div style={cutoutStyle} />}
        </div>
      )}
    />
    <TourCardHeadless
      render={({
        currentStep,
        isFirstStep,
        isLastStep,
        next,
        prev,
        skip,
        floatingStyles,
        refs,
      }) => (
        <div
          ref={refs.setFloating}
          style={floatingStyles}
          role="dialog"
          aria-modal="true"
          aria-labelledby="definity-tour-step-title"
          className="z-modal-above flex w-80 max-w-[90vw] flex-col gap-2 rounded-lg border default-border-color bg-background-paper p-4 shadow-xl"
        >
          {currentStep?.title != null && (
            <h3 id="definity-tour-step-title" className="text-sm font-medium m-0">
              {currentStep.title as ReactNode}
            </h3>
          )}
          {currentStep?.content != null && (
            <div className="text-sm text-grey-300">
              {currentStep.content as ReactNode}
            </div>
          )}
          <div className="flex items-center justify-between gap-2 pt-1">
            <Button
              variant="text"
              className="min-w-0"
              onClick={skip}
              data-ph-capture-attribute-action="tour_skip"
            >
              Skip
            </Button>
            <div className="flex gap-1">
              {!isFirstStep && (
                <Button
                  variant="text"
                  onClick={prev}
                  data-ph-capture-attribute-action="tour_back"
                >
                  Back
                </Button>
              )}
              <Button
                variant="contained"
                onClick={next}
                data-ph-capture-attribute-action={
                  isLastStep ? "tour_finish" : "tour_next"
                }
              >
                {isLastStep ? "Done" : "Next"}
              </Button>
            </div>
          </div>
        </div>
      )}
    />
  </>
);

export default DefinityTourShell;
